import React from "react";

/* Mobile number field layout (country dial code + phone input) — replaces legacy uiComponents MobileField. */
export function MobileField({ label, className = "", isMandatory = true, children, style, ...rest }) {
  return (
    <div className={`mobile-field ${className}`.trim()} style={style} {...rest}>
      {label ? (
        <label style={{ marginBottom: 8, fontSize: 14, fontWeight: 600, lineHeight: 1 }}>
          {label}
          {isMandatory ? "*" : ""}
        </label>
      ) : null}
      <div className="mobile-field-inputs">{children}</div>
      <style>{`
        .mobile-field-inputs {
          display: flex;
          align-items: flex-start;
          gap: 8px;
        }
        .mobile-field-inputs > input[type="hidden"] {
          display: none;
        }
        .mobile-field-inputs > div > label {
          display: none;
        }
        .mobile-field-inputs > div {
          margin-bottom: 0 !important;
          flex: 1;
          min-width: 0;
        }
        .mobile-field-inputs > div:first-of-type {
          flex: 0 0 auto;
        }
        .mobile-field-inputs .ds-input-box {
          height: var(--control-h-sm) !important;
          min-height: var(--control-h-sm) !important;
        }
      `}</style>
    </div>
  );
}

export default MobileField;
